export const designationHook = (partNumber: string) => {
    let desigation = '';
    if (!partNumber) return;
    if (partNumber.includes('-')) {
        desigation = partNumber.substring(0, 5);
        return desigation;
    }
    return partNumber;
};
